import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const USES = [
  'Client gifts', 'Realtor closing gifts', 'Mortgage & financing celebrations', 'Financial advisor client appreciation',
  'Corporate Christmas gifts', 'Employee recognition', 'Weddings & events', 'Airbnb & vacation rental welcome gifts',
  'Restaurants & hospitality', 'Construction / project completion gifts', 'Professional services', 'Special events & milestones',
];

/** "Make It Yours." — custom label section; hero bottle = first featured showcase render. */
const CorpMakeItYours = ({ onExplore, onOrder }) => {
  const [bottle, setBottle] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/portfolio/public`).then((r) => {
      const items = r.data.items || [];
      const pick = items.find((i) => i.featured && i.category === 'business') || items[0];
      if (pick) setBottle(pick);
    }).catch(() => {});
  }, []);

  return (
    <section className="ff-section" data-testid="corp-make-it-yours">
      <div className="ff-container corp-labels-grid">
        <div className="corp-labels-bottle" data-testid="corp-labels-bottle">
          {bottle ? (
            <img src={`${BACKEND_URL}${bottle.bottleUrl}`} alt={`${bottle.name} custom label on a Lokal bottle`} />
          ) : (
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ff-brown-soft)', fontSize: 14 }}>
              Your label here
            </div>
          )}
        </div>
        <div style={{ textAlign: 'left' }}>
          <p className="ff-eyebrow" style={{ color: 'var(--ff-gold)' }}>CUSTOM LABELS</p>
          <h2 style={{ textAlign: 'left' }}>Make It Yours.</h2>
          <span className="corp-labels-price" data-testid="corp-label-price">Custom Labels — $1.50 per label</span>
          <p className="ff-lede" style={{ marginTop: 10, textAlign: 'left' }}>
            Turn your wine into an extension of your business, event or brand. Upload your own
            finished label design, use existing artwork, or decide on your design later.
          </p>
          <ul className="corp-labels-uses">
            {USES.map((u) => <li key={u}>{u}</li>)}
          </ul>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 24 }}>
            <button className="ff-btn ff-btn-primary" onClick={() => onOrder('labels_create')} data-testid="corp-labels-create">Create Your Corporate Wine</button>
            <button className="ff-btn ff-btn-ghost" onClick={onExplore} data-testid="corp-labels-explore">Explore Custom Labels ↓</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorpMakeItYours;
